import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import Chatbot from './components/Chatbot';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1FBDBD',
      dark: '#17A0A0',
      contrastText: '#ffffff',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Chatbot />
      </div>
    </ThemeProvider>
  );
}

export default App; 